<template>
  <nav class="mini-stepper" aria-label="Booking steps">
    <div
      v-for="(step, i) in steps"
      :key="step.label"
      class="mini-step"
      :class="{ active: i === activeStep, completed: i < activeStep }"
    >
      <div class="mini-bar" />
      <div class="mini-label">
        <!-- green checkmark for completed steps -->
        <span v-if="i < activeStep" class="mini-check">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <circle cx="8" cy="8" r="8" class="mini-check-bg" />
            <path
              class="mini-check-mark"
              d="M4 8.4L6.5 11 12 5.5"
              fill="none"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <span class="mini-label-text">
          {{ step.label }}
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'BookingStepper',
  props: {
    activeStep: { type: Number, default: 0 },
    steps: {
      type: Array,
      default: () => [
        { label: 'Party Size' },
        { label: 'Room Selection' },
        { label: 'Preferences' },
        { label: 'Guest Info' },
        { label: 'Pay' },
      ]
    }
  }
}
</script>

<style scoped>
.mini-stepper {
  --bar-muted: #e6e8ec;
  --bar-active: #24388e;
  --bar-completed: #29B7B4; /* ✅ green for completed */
  --label-muted: rgba(0, 0, 0, 0.56);
  --label-active: var(--bar-active);
  --label-completed: #239492; /* darker green text */

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 0 8px;

  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  touch-action: pan-x;
}

.mini-stepper::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.mini-step {
  min-width: 110px;
  text-align: center;
  flex: 1 1 0;
}

.mini-bar {
  height: 6px;
  width: 140px;
  max-width: 100%;
  background: var(--bar-muted);
  border-radius: 999px;
  transition: background-color 0.25s ease;
}

.mini-label {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.mini-label-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--label-muted);
  white-space: normal;      /* ✅ allow wrapping */
  text-align: center;       /* ✅ center-align wrapped text */
  display: inline-block;    /* ✅ keeps proper width */
  line-height: 1.2;         /* ✅ tighter spacing between lines */
  word-break: break-word;   /* ✅ force break on long words */
  max-width: 90px;          /* ✅ optional constraint for mobile */
}


/* ✅ checkmark */
.mini-check {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.mini-check svg {
  width: 100%;
  height: 100%;
}
.mini-check-bg {
  fill: #dcfce7; /* soft green background */
}
.mini-check-mark {
  stroke: #29B7B4; /* strong green stroke */
}

/* ACTIVE step (blue) */
.mini-step.active .mini-bar {
  background: var(--bar-active);
}
.mini-step.active .mini-label-text {
  color: var(--label-active);
}

/* COMPLETED steps (green) */
.mini-step.completed:not(.active) .mini-bar {
  background: var(--bar-completed);
}
.mini-step.completed:not(.active) .mini-label-text {
  color: var(--label-completed);
}

@media (max-width: 420px) {
  .mini-step {
    min-width: 110px;
  }
  .mini-bar {
    width: 120px;
  }
}
</style>
